// import { connect } from 'react-redux';

import axios from "axios";
import { get_v10_url } from "./commonUtilities";

let base_url = "https://devapi.plunes.com/v10";
let base_url_without_v5 = "https://devapi.plunes.com";

const pathLocation = window.location.host;
if (!!pathLocation) {
  if (
    pathLocation === "cashless.plunes.com" ||
    pathLocation === "cashlessprod.s3-website.ap-south-1.amazonaws.com"
  ) {
    // if(true){
    // Production baseUrl
    base_url = "https://api.plunes.com/v10";
  } else {
    base_url = "https://devapi.plunes.com/v10";
  }
}

let admin_url = "https://devapi.plunes.com/admin";
let prod_admin_url = "https://api.plunes.com/admin";

const admin_location = window.location.host;
if (!!admin_location) {
  // if(admin_location === "s3.console.aws.amazon.com") {
  if (
    admin_location === "cashless.plunes.com" ||
    admin_location === "cashlessprod.s3-website.ap-south-1.amazonaws.com"
  ) {
    // console.log("Prod");
    // Production baseUrl
    admin_url = "https://api.plunes.com/admin";
  } else {
    admin_url = "https://devapi.plunes.com/admin";
  }
}

let insurance_admin_url = "https://devapi.plunes.com/insurance";
let prod_insurance_admin_url = "https://api.plunes.com/insurance";

const insurance_admin_location = window.location.host;
if (!!insurance_admin_location) {
  // if(insurance_admin_location === "s3.console.aws.amazon.com") {
  if (
    insurance_admin_location === "cashless.plunes.com" ||
    insurance_admin_location === "cashlessprod.s3-website.ap-south-1.amazonaws.com"
  ) {
    // console.log("Prod");
    // Production baseUrl
    insurance_admin_url = "https://api.plunes.com/v10/insurance";
  } else {
    insurance_admin_url = "https://devapi.plunes.com/v10/insurance";
  }
}

let new_url = "https://devapi.plunes.com/mcm";
// let prod_new_url = "https://api.plunes.com/mcm"

const location = window.location.host;
if (!!location) {
  // if(admin_location === 's3.console.aws.amazon.com') {
  if (
    location === "cashless.plunes.com" ||
    location === "cashlessprod.s3-website.ap-south-1.amazonaws.com"
  ) {
    // console.log("PROD");
    // Production baseUrl
    new_url = "https://api.plunes.com/mcm";
  } else {
    new_url = "https://devapi.plunes.com/mcm";
  }
}

let new_url_2 = "https://devapi.plunes.com";
// let prod_new_url = "https://api.plunes.com/mcm"

const new_location = window.location.host;
if (!!new_location) {
  // if(admin_location === 's3.console.aws.amazon.com') {
  if (
    new_location === "cashless.plunes.com" ||
    new_location === "cashlessprod.s3-website.ap-south-1.amazonaws.com"
  ) {
    // console.log("PROD");
    // Production baseUrl
    new_url_2 = "https://api.plunes.com";
  } else {
    new_url_2 = "https://devapi.plunes.com";
  }
}

export default {
  auth: {
    login: (data, headers) =>
      axios
        .post(`${get_v10_url()}/professional/login`, data)
        .then((res) => {
          // console.log(res, "res in login api");
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in login api");
          return err;
        }),
    register: (data, headers) =>
      axios
        .post(`${insurance_admin_url}/register`, data)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          // console.log(err.response.data, "err in register api");
          return err.response ? err.response : err;
        }),
    logout: (data, headers) =>
      axios
        .get(`${insurance_admin_url}/mcm/mcmUser/logout`, headers)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in logut api");
          return err;
        }),
    whoami: (data, headers) =>
      axios
        .get(`${get_v10_url()}/professional/whoami`, data)
        // .get(`http:localhost:5003:/professional/whoami`, data)
        .then((res) => {
          // console.log(res, "res in whoami api");
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in login api");
          return err;
        }),
  },
  dashboard: {
    getPatientDetails: (data, headers) =>
      axios
        .get(`${insurance_admin_url}/getDashPatientDetails`, headers)
        .then((res) => {
          // console.log(res, "res in login api");
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in login api");
          return err;
        }),
  },
  patientsStats: {
    getPatientStats: (data = {}, headers = {}, filters = {}) =>
      axios
        .get(`${get_v10_url()}/professional/getBookingStats?date=${filters.date}&location=${filters.location}`, { headers })
        .then((res) => {
          // console.log(res, "res in stats api");
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in stats api");
          return err;
        }),
    getClaimAmount: (data = {}, headers = {}, filters = {}) =>
      axios
        .get(`${get_v10_url()}/professional/claimAmountDetails?date=${filters.date}&location=${filters.location}`, { headers })
        .then((res) => {
          // console.log(res, "res in claim amount api");
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in claim amount api");
          return err;
        }),
  },
  patientsDetails: {
    getPatientDetails: (data = {}, headers = {}, filters = {}) =>
      axios
        .get(`${get_v10_url()}/professional/getInsuranceBookings?date=${filters.date}&location=${filters.location}&limit=${filters.limit || 10}`, { headers })
        .then((res) => {
          // console.log(res, "res in details api");
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in details api");
          return err;
        }),
  },
  patientsBar: {
    getPatientsBar: (data = {}, headers = {}) =>
      axios
        .get(`${get_v10_url()}/professional/claimAmountDetailsGroups`, { headers })
        .then((res) => {
          // console.log(res, "res in patients bar api");
          // console.log({ v10url: get_v10_url() })
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in patients bar api");
          return err;
        }),
  },
  insuranceStats: {
    getInsuranceStats: (data = {}, headers = {},filters={}) =>
      axios
        .get(`${get_v10_url()}/professional/getInsuranceStats?date=${filters.date}&location=${filters.location}`, { headers })
        .then((res) => {
          // console.log(res, "res in patients bar api");
          // console.log({ v10url: get_v10_url() })
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in patients bar api");
          return err;
        }),
  },
  patients: {
    getPatientDetails: (data, headers) => {
      let url = `${insurance_admin_url}/getPatientDetails?page=${!!data.page ? data.page : ""
        }&limit=${!!data.limit ? data.limit : ""}`;
      if (!!data.searchParams) {
        if (data.searchParams !== {}) {
          let keys = Object.keys(data.searchParams);
          // console.log(keys, "keys in api");
          keys.map((item, i) => {
            // console.log(item, "item in data>searchParams");
            url =
              url +
              `&${keys[`${i}`]}=${!!data.searchParams[`${keys[i]}`]
                ? data.searchParams[`${keys[i]}`]
                : ""
              }`;
          });
        }
      }
      if (!!data.filters) {
        if (data.filters !== {}) {
          let keys = Object.keys(data.filters);
          // console.log(keys, "keys in api");
          keys.map((item, i) => {
            // console.log(item, "item in data>filters");
            url =
              url +
              `&${keys[`${i}`]}=${!!data.filters[`${keys[i]}`] ? data.filters[`${keys[i]}`] : ""
              }`;
          });
        }
      }
      if (!!data.intFilters) {
        if (data.intFilters !== {}) {
          let keys = Object.keys(data.intFilters);
          // console.log(keys, "keys in api");
          keys.map((item, i) => {
            // console.log(item, "item in data>intFilters");
            url =
              url +
              `&${keys[`${i}`]}=${data.intFilters[`${keys[i]}`].minimum +
              "by" +
              data.intFilters[`${keys[i]}`].maximum
              }`;
          });
        }
      }
      if (!!data.dateFilters) {
        if (data.dateFilters !== {}) {
          let keys = Object.keys(data.dateFilters);
          // console.log(keys, "keys in api");
          keys.map((item, i) => {
            // console.log(item, "item in data>dateFilters");
            // console.log(
            //   data.dateFilters[`${keys[i]}`],
            //   "item ksdjksdjkldsjksdjfkdsf"
            // );
            if (data.dateFilters[`${keys[i]}`].length !== 0) {
              url =
                url +
                `&${keys[`${i}`]}=${data.dateFilters[`${keys[i]}`][0] +
                "-" +
                data.dateFilters[`${keys[i]}`][1]
                }`;
            }
          });
        }
      }
      return axios
        .get(url, headers)
        .then((res) => {
          // console.log(res, "res in login api");
          return res.data;
        })
        .catch((err) => {
          // console.log(err, "err in login api");
          return err;
        })
    },
  },
  booking: {
    getBookingAL: (data, headers) =>
      axios
        .get(`${get_v10_url()}/professional/getBookingByAL?alNumber=${data.alNumber}`, headers, data)
        .then((res) => {
          // console.log(res, "res in login api");
          return res.data;
        })
    ,
    getBookingById: (data, headers) =>
      axios
        .get(`${get_v10_url()}/professional/getBookingById?bookingId=${data.booking_id}`, headers, data)
        .then((res) => {
          // console.log(res, "res in login api");
          return res.data;
        })
    ,
    updateBooking: (data,headers) =>
      axios
        .post(`${get_v10_url()}/professional/updateBooking?bookingId=${data.bookingId}&billFlag=${data.billFlag ? data.billFlag : false}&enhancement=${data.enhancement ? data.enhancement : false}&updateMsg=${data.updateMsg}&preAuth=${data.preAuth}`,data, headers)
        .then((res) => {
          // console.log(res, "res in update booking api");
          return res.data;
        })
    ,
    getProfessionalBookings: (data, headers) => {
      let url = `${get_v10_url()}/professional/getProfessionalBookings?page=${data.page ? data.page : ''
        }&limit=${data.limit ? data.limit : ''}`;
      if (!!data.searchParams) {
        if (data.searchParams !== {}) {
          let keys = Object.keys(data.searchParams);
          // console.log(keys, 'keys in api');
          keys.map((item, i) => {
            // console.log(item, 'item in data>searchParams');
            url =
              url +
              `&${keys[`${i}`]}=${!!data.searchParams[`${keys[i]}`]
                ? data.searchParams[`${keys[i]}`]
                : ''
              }`;
          });
        }
      }
      if (!!data.filters) {
        if (data.filters !== {}) {
          let keys = Object.keys(data.filters);
          // console.log(keys, 'keys in api');
          keys.map((item, i) => {
            // console.log(item, 'item in data>filters');
            url =
              url +
              `&${keys[`${i}`]}=${!!data.filters[`${keys[i]}`] ? data.filters[`${keys[i]}`] : ''
              }`;
          });
        }
      }
      if (!!data.intFilters) {
        if (data.intFilters !== {}) {
          let keys = Object.keys(data.intFilters);
          // console.log(keys, 'keys in api');
          keys.map((item, i) => {
            // console.log(item, 'item in data>intFilters');
            url =
              url +
              `&${keys[`${i}`]}=${data.intFilters[`${keys[i]}`].minimum +
              'by' +
              data.intFilters[`${keys[i]}`].maximum
              }`;
          });
        }
      }
      if (!!data.dateFilters) {
        if (data.dateFilters !== {}) {
          let keys = Object.keys(data.dateFilters);
          // console.log(keys, 'keys in api');
          keys.map((item, i) => {
            // console.log(item, 'item in data>dateFilters');
            // console.log(
            //   data.dateFilters[`${keys[i]}`],
            //   'item ksdjksdjkldsjksdjfkdsf'
            // );
            if (data.dateFilters[`${keys[i]}`].length !== 0) {
              url =
                url +
                `&${keys[`${i}`]}=${data.dateFilters[`${keys[i]}`][0] +
                '-' +
                data.dateFilters[`${keys[i]}`][1]
                }`;
            }
          });
        }
      }
      return axios
        .get(`${url}`, headers)
        .then((res) => {
          // console.log(res, 'res in get_professionals');
          return res.data;
        })
    },
    uploadReport: (data, headers) =>
      axios
        .post(`${get_v10_url()}/professional/userReport?reportType=${data.type}`, data.files, headers)
        .then(res => {
          return res
        }),
    uploadInsurance: (data, headers) =>
      axios
        .post(`${get_v10_url()}/professional/uploadInsurance?insuranceType=${data.type}`, data.files, headers)
        .then(res => {
          return res
        }),


  }
};
